import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "MDX Layout Components"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "mdx-layout-components"
    }}>{`MDX Layout Components`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component can be nested within a parent `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{`,
allowing you to contextually adjust styles in certain parts of a UI.
This functionality can be leveraged to create custom layout components that
take MDX content as children to create uniquely styled blocks of content.
For example this site's `}<a parentName="p" {...{
        "href": "/"
      }}>{`landing page`}</a>{` uses this approach to style its content,
which is written in MDX.`}</p>
    <p>{`As an example, create a new component with the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` and a wrapping `}<inlineCode parentName="p">{`<div>`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "filename=Layout.js",
        "filename": "Layout.js"
      }}>{`/** @jsxImportSource theme-ui */
import { ThemeProvider } from 'theme-ui'

export default (props) => (
  <ThemeProvider theme={{}}>
    <div {...props} />
  </ThemeProvider>
)
`}</code></pre>
    <p>{`To add styles to this component, augment the required `}<inlineCode parentName="p">{`theme`}</inlineCode>{` prop and add an `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop to the `}<inlineCode parentName="p">{`div`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "filename=Layout.js",
        "filename": "Layout.js"
      }}>{`/** @jsxImportSource theme-ui */
import { ThemeProvider } from 'theme-ui'

export default (props) => (
  <ThemeProvider
    theme={{
      styles: {
        // style child elements
        h1: {
          fontSize: [5, 6, 7],
        },
      },
    }}>
    <div
      {...props}
      sx={{
        // swap colors for an inverted effect
        color: 'background',
        bg: 'primary',
        px: 3,
        py: 4,
      }}
    />
  </ThemeProvider>
)
`}</code></pre>
    <p>{`The component above can then be imported and used within an MDX document.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`import MyLayout from './MyLayout'

<MyLayout>

# Hello

This section has custom styles

</MyLayout>

This part of the document uses default styles
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      